import React from 'react';

const SettingsFormGroup = ({ children }) => (
  <div className="settings-form__form-group">{children}</div>
);

export default SettingsFormGroup;
